import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Transition as _Transition, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e5589f2e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "ball-main" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " This animation uses the transition component. ", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Bounce the Ball!", -1))
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_animation_child = _resolveComponent("animation-child")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleShow && _ctx.toggleShow(...args)))
    }, [
      (_ctx.isShowing)
        ? (_openBlock(), _createElementBlock("span", _hoisted_4, "Get it gone!"))
        : (_openBlock(), _createElementBlock("span", _hoisted_5, "Here we go!"))
    ]),
    _createVNode(_Transition, {
      name: "ballmove",
      "enter-active-class": "bouncein",
      "leave-active-class": "rollout"
    }, {
      default: _withCtx(() => [
        (_ctx.isShowing)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(_component_animation_child, { class: "child" })
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}